import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import React from "react";
import { baseFontStyle, menuItemTextStyle } from "../../tickets/tickets";

const RcaDialog = (props) => {
    const {rcaDialog,rcaText, handleRcaDialogClose, handleRcaTextChange, handleSaveRca} = props
  return (
    <Dialog
      open={rcaDialog}
      onClose={handleRcaDialogClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          ...baseFontStyle,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Root Cause Analysis (RCA)
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={8}
          value={rcaText}
          onChange={handleRcaTextChange}
          placeholder="Enter Root Cause Analysis..."
          sx={{
            mt: 2,
            "& .MuiInputLabel-root": menuItemTextStyle,
            "& .MuiInputBase-input": menuItemTextStyle,
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleRcaDialogClose}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSaveRca}
          disabled={rcaText.trim() === ""}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
        >
          Save RCA
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RcaDialog;
